// TODO: (D.Katsar) "customCoefficient = 6" - this is hard-coded value. need improve this coefficient for calculate
const customCoefficient = 6;
export function getScaleValue({ minWidth, maxWidth, gutterLeftHolderSize, extraGutterSize, isOffsetOff, }) {
    if (!isOffsetOff) {
        return 0;
    }
    const calculateValue = Math.floor(maxWidth) - minWidth - gutterLeftHolderSize + extraGutterSize + customCoefficient;
    return -calculateValue;
}
